// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    loadProductFirst: true,
    refineByStyle: 'style2',
    filterTreeMobileStyle: 'style1',

    // Enable infinite pagination
    paginationType: 'infinite',

    // Optional
    activeLoadPreviousPage: true,
    paginationTypeAdvanced: true
  },
};

const DEFAUT_VENDOR = "Rokit";
var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    if (localStorage.getItem('perRowClass') !== null) {
      boostPFSConfig.custom.grid_item_width=localStorage.getItem("perRowClass")
    } else {
      boostPFSConfig.custom.grid_item_width="medium-up--one-quarter"
    }

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);


    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      if ( images.length > 1 ) {
          itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + ' grid__image-multiple">';
          itemImagesHtml += '<img ' +
          'class="lazyload ' + productGridImageFillClass + '" ' +
          'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
          'data-widths="[360, 540, 720, 900, 1080]" ' +
          'data-aspectratio="' + aspectRatio + '" ' +
          'data-sizes="auto" ' +
          'alt="{{itemTitle}}">';

          itemImagesHtml += '<img ' +
          'class="lazyload ' + productGridImageFillClass + '" ' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '" ' +
          'data-widths="[360, 540, 720, 900, 1080]" ' +
          'data-aspectratio="' + aspectRatio + '" ' +
          'data-sizes="auto" ' +
          'alt="{{itemTitle}}">';
          itemImagesHtml += '</div>';
        } else {
          itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
          itemImagesHtml += '<img ' +
            'class="lazyload ' + productGridImageFillClass + '" ' +
            'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
            'data-widths="[360, 540, 720, 900, 1080]" ' +
            'data-aspectratio="' + aspectRatio + '" ' +
            'data-sizes="auto" ' +
            'alt="{{itemTitle}}">';
          itemImagesHtml += '</div>';
        }
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    } else {
      if (onSale) {
        itemPriceHtml += '<span class="grid-product__price--sale">' + Utils.formatMoney(data.price_min) + '</span>';
      } else {
        itemPriceHtml += Utils.formatMoney(data.price_min);
      }
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
        savePrice += '%';
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });


    // Add BNWT label
    var bnwtLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('BNWT|True')) {
        if (!bnwtLabel) {
          bnwtLabel = true;
        }
      }
    });

    // Add Deadstock label
    var deadstockLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('ATT|Condition|Deadstock')) {
        if (!deadstockLabel) {
          deadstockLabel = true;
        }
      }
    });

    var itemLabelHtml = '';
    var icon_sale = '<svg xmlns="http://www.w3.org/2000/svg" width="63.399" height="56.811" viewBox="0 0 63.399 56.811"><defs><style>.isa{fill:#fe441d;}.isb{fill:#3c3c3c;font-size:14px;font-family:WorkSans-Bold, Work Sans;font-weight:700;}</style></defs><path class="isa" d="M-563.08,334.286c-2.785-4.3-2.542-11.205-2.542-11.205H-584.8a3.046,3.046,0,0,1-3.03,3.062,3.046,3.046,0,0,1-3.029-3.062h-19.175s.242,6.9-2.542,11.205c-2.338,3.612-2.338,9.446,0,12.589,2.87,3.859,2.542,11.205,2.542,11.205h19.175a3.046,3.046,0,0,1,3.029-3.062,3.046,3.046,0,0,1,3.03,3.062h19.175s-.327-7.346,2.542-11.205C-560.742,343.732-560.742,337.9-563.08,334.286Z" transform="translate(370.482 -560.46) rotate(-30)"/><text class="isb" transform="translate(19.5 41.257) rotate(-30)"><tspan x="0" y="0">SALE</tspan></text></svg>';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + icon_sale + '</div>';
      }
    }

    /* BNWT label */
    var icon_new = '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="50" viewBox="0 0 52 50"><defs><style>.cls-1{fill:#37fe1d;}.cls-2{fill:#3c3c3c;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path id="Polygon_15" data-name="Polygon 15" class="cls-1" d="M34,0l4.32,7.81L47,9.55l-1,8.88L52,25l-6,6.57,1,8.88-8.68,1.74L34,50l-8-3.75L18,50l-4.32-7.81L5,40.45l1-8.88L0,25l6-6.57L5,9.55l8.68-1.74L18,0l8,3.75Z"/><path class="cls-2" d="M23.91,22.63l2.78,6-1.56.73-2.78-6Zm1-4.22-.56-1.2-3.22,1.5-.57-1.23L23,16.33,22.5,15.2,20,16.35l-.56-1.21,3.1-1.45L22,12.49l-4.65,2.17,2.78,6Zm3.84-1.79-.65-3.23-.42-1.58h0l.95,1.34,2.06,2.57,1.7-.79L31.35,8.13l-1.61.75,1.2,5.17-3.29-4.2-1.41.66,1.13,5.22-3.22-4.25-1.66.78L27,17.44Zm.79,10.67,1.56-.73-2.23-4.78,1.95-.9-.56-1.21-5.47,2.55.56,1.2,2-.91Zm3.17-8.76-1.56.73,2.78,6,1.56-.73L34.37,22.1,36.65,21l1.13,2.42,1.56-.73-2.79-6L35,17.46l1.1,2.37-2.28,1.06ZM14.8,23.13l-1.41-3L12.84,19h0l.86.67,3.37,2.37,1.73-.8-2.79-6-1.38.65,1.41,3L16.6,20h0l-.86-.68L12.36,17l-1.73.81,2.79,6Zm18.31,9.6.48,1L35,33.13l0,.09a1.28,1.28,0,0,1,.11.49.88.88,0,0,1-.11.42,1.39,1.39,0,0,1-.29.36,2,2,0,0,1-.45.29,1.78,1.78,0,0,1-.92.18,1.36,1.36,0,0,1-.79-.4,3,3,0,0,1-.66-1,3.07,3.07,0,0,1-.32-1.09,1.47,1.47,0,0,1,.19-.85,1.55,1.55,0,0,1,.66-.57,1.37,1.37,0,0,1,.84-.14,1.19,1.19,0,0,1,.73.48l1.18-1.25a2.67,2.67,0,0,0-1.51-.71,3.53,3.53,0,0,0-1.82.4A3.46,3.46,0,0,0,30.44,31a2.78,2.78,0,0,0-.55,1.55,4,4,0,0,0,.41,1.82,4.17,4.17,0,0,0,1.13,1.52,2.63,2.63,0,0,0,1.45.59,3.09,3.09,0,0,0,1.58-.31,2.45,2.45,0,0,0,1.12-.92,1.7,1.7,0,0,0,.24-.76l.43.74,1.06-.49L35.8,31.47ZM18.34,29l-.41-1.59h0l.95,1.33L21,31.29l1.69-.79-1.06-6.79-1.6.75,1.2,5.18L17.9,25.43l-1.42.66,1.13,5.22L14.4,27.07l-1.66.77L17.25,33,19,32.2ZM42.5,30a1.55,1.55,0,0,0-.91-.87,3.17,3.17,0,0,0-1.6,0l-1.11.25a1.66,1.66,0,0,1-.68,0,.42.42,0,0,1-.33-.24.54.54,0,0,1,0-.33.72.72,0,0,1,.2-.34,2,2,0,0,1,.51-.32,2.63,2.63,0,0,1,1.12-.27,2.86,2.86,0,0,1,1.12.22l.28-1.36a3.28,3.28,0,0,0-1.46-.24A4.31,4.31,0,0,0,38,27a3.79,3.79,0,0,0-1.27.9A2.28,2.28,0,0,0,36.17,29a2,2,0,0,0,.16,1.14,1.62,1.62,0,0,0,.62.73,1.75,1.75,0,0,0,.86.23,4.36,4.36,0,0,0,1-.11l1.22-.27a1.47,1.47,0,0,1,.62,0A.53.53,0,0,1,41,31a.61.61,0,0,1,0,.35.69.69,0,0,1-.23.33,1.79,1.79,0,0,1-.5.31,2.86,2.86,0,0,1-.86.26,3.18,3.18,0,0,1-.87,0,2.8,2.8,0,0,1-.78-.21l-.26,1.39a3.12,3.12,0,0,0,1,.22,4.2,4.2,0,0,0,1.16-.08,5.13,5.13,0,0,0,1.2-.4,3.87,3.87,0,0,0,1.2-.83,2.07,2.07,0,0,0,.59-1.08A1.9,1.9,0,0,0,42.5,30ZM23.67,35.24,23.11,34l-5.47,2.55.56,1.2,2-.91,2.23,4.78L24,40.93l-2.23-4.78Zm2.92-2.82,4.88,5-1.61.75-1-1.16-2.06,1L27,39.52l-1.56.73-.69-7Zm.31,2.45-.7-.82h0l.19,1,.23,1.65L28,36.1Z"/></g></g></svg>';
    if(bnwtLabel){
      itemLabelHtml += '<div class="grid-product__tag grid-product__tag--new'+ (onSale ? ' grid-product__tag--bnwt-with-sale' : '') +'">' + icon_new + '</div>';
    }
    
    /* Deadstock Icon */
    var icon_deadstock = '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="50" viewBox="0 0 54 44"><g data-name="Layer 2"><g data-name="Promo Desktop Deadstock"><path fill="#d7ff50" d="M38.9 44 0 29.3 10.8 0l38.9 13.6L54 32.5 38.9 44Zm9.4-13.7a1 1 0 1 0 1 1 1 1 0 0 0-1-1Z" data-name="Subtraction 1"/><path fill="#3c3c3c" d="M15.7 16.6a3.7 3.7 0 0 0 1.8-2.2 3.9 3.9 0 0 0 .1-2.8 3.79 3.79 0 0 0-2.1-1.8l-2.9-1.1-2.5 6.8 2.9 1.1a3.17 3.17 0 0 0 2.7 0Zm-1.9-5.9.9.3a1.59 1.59 0 0 1 1.1 1 2.71 2.71 0 0 1-.2 1.7 2.55 2.55 0 0 1-1 1.4 1.56 1.56 0 0 1-1.5.1l-.9-.3Zm3.7 7.5 2.5-6.8 5.3 1.9-.5 1.4-3.5-1.3-.5 1.4 2.8 1-.5 1.3-2.8-1-.5 1.4 3.7 1.3-.5 1.4Zm7.6 2.8 1-1.4 2.4.9-.1 1.7 1.8.7.1-7.7-2.1-.8-4.9 6Zm3.6-4.9-.1 1.2-.1 1.8-1.6-.6L28 17Zm8 8.1a3.7 3.7 0 0 0 1.8-2.2 3.9 3.9 0 0 0 .1-2.8 3.48 3.48 0 0 0-2.1-1.8l-2.9-1.1-2.6 6.8 2.9 1.1a3.4 3.4 0 0 0 2.8 0Zm-1.9-5.9.9.3a1.59 1.59 0 0 1 1.1 1 2.71 2.71 0 0 1-.2 1.7 3.16 3.16 0 0 1-1 1.4 1.56 1.56 0 0 1-1.5.1l-.9-.3Zm8.3 6.9-3.8-1.4.5-1.4 3.8 1.4Zm-32.8-5.6c-.1.1 0 .3.1.4a3.81 3.81 0 0 0 .6.5l1.1.7a3.4 3.4 0 0 1 1.2 1.2 1.7 1.7 0 0 1 0 1.4 2.26 2.26 0 0 1-.8 1.1 2.84 2.84 0 0 1-1.3.4 5 5 0 0 1-1.6-.3 6.66 6.66 0 0 1-1.2-.6 8.74 8.74 0 0 1-1-.8 2.36 2.36 0 0 1-.6-.9l1.3-.9a3 3 0 0 0 .4.8c.2.2.5.4.7.6a4.05 4.05 0 0 0 .9.5 1.49 1.49 0 0 0 .6.1c.2 0 .3 0 .4-.1s.2-.2.2-.3V23a2.25 2.25 0 0 0-.5-.5l-1.2-.7a3.51 3.51 0 0 1-.9-.7 2.62 2.62 0 0 1-.5-.9 1.18 1.18 0 0 1 .1-1 2 2 0 0 1 .8-1 2.84 2.84 0 0 1 1.3-.4 5.55 5.55 0 0 1 1.7.3 4.17 4.17 0 0 1 1.6.9 6.42 6.42 0 0 1 1 1.3l-1.3.8a2.55 2.55 0 0 0-.7-1 3 3 0 0 0-1.1-.7 2 2 0 0 0-.7-.1c-.2 0-.3 0-.4.1Zm11 3.4-2.3-.8-2 5.4-1.7-.6 2-5.4-2.3-.9.5-1.4 6.2 2.3Zm5.9 1a3.81 3.81 0 0 0-1.6-1.1 3.2 3.2 0 0 0-1.9-.2 3.46 3.46 0 0 0-1.6.8 4.18 4.18 0 0 0-1.1 1.7 3.64 3.64 0 0 0-.3 2 2.93 2.93 0 0 0 .7 1.6 3.81 3.81 0 0 0 1.6 1.1 3.2 3.2 0 0 0 1.9.2 3.46 3.46 0 0 0 1.6-.8 4.18 4.18 0 0 0 1.1-1.7 3.64 3.64 0 0 0 .3-2 2.36 2.36 0 0 0-.7-1.6Zm-1.4 3a5.42 5.42 0 0 1-.6 1.1 1 1 0 0 1-.8.5 1 1 0 0 1-.9-.1 2.18 2.18 0 0 1-.8-.5 1.22 1.22 0 0 1-.3-.9 5 5 0 0 1 .2-1.2 5.42 5.42 0 0 1 .6-1.1 1.37 1.37 0 0 1 .8-.5 1 1 0 0 1 .9.1 1.28 1.28 0 0 1 .7.5 1.22 1.22 0 0 1 .3.9c.2.3.1.7-.1 1.2Zm7.1 3.7 1.4 1a3.13 3.13 0 0 1-1.1.9 2.77 2.77 0 0 1-1.3.3 3.53 3.53 0 0 1-1.4-.3 3.81 3.81 0 0 1-1.6-1.1 3.29 3.29 0 0 1-.7-1.6 3.64 3.64 0 0 1 .3-2 4.18 4.18 0 0 1 1.1-1.7 3.46 3.46 0 0 1 1.6-.8 4.27 4.27 0 0 1 1.9.2 3.46 3.46 0 0 1 1.2.7 2.54 2.54 0 0 1 .8 1 2.74 2.74 0 0 1 .2 1.3l-1.8.1a1.89 1.89 0 0 0-.1-1.1 1.79 1.79 0 0 0-.7-.5 2.77 2.77 0 0 0-.9-.1 1.37 1.37 0 0 0-.8.5 5.42 5.42 0 0 0-.6 1.1 1.88 1.88 0 0 0-.2 1.2 1.22 1.22 0 0 0 .3.9 2.76 2.76 0 0 0 .8.6 1.39 1.39 0 0 0 .9 0 1.34 1.34 0 0 0 .7-.6Zm10.4-1.2L40 31.4l1 4.9-2-.7-.6-3.5-1.2.7-.7 1.9-1.8-.6 2.5-6.8 1.8.6-1.1 3 3.5-2.1Z"/></g></g></svg>';
    if(deadstockLabel){
      itemLabelHtml += '<div class="grid-product__tag'+ (onSale ? ' grid-product__tag--bnwt-with-sale' : '') +'">' + icon_deadstock + '</div>';
    }


    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    if (data.vendor != 'Other') {
      spacedVendor = data.vendor.replace(',', ', ')

      // Update Rokit to Vintage or the default brand. Grab it from Theme settings
      if (spacedVendor == "Rokit" || spacedVendor == "") {
        spacedVendor = DEFAUT_VENDOR;
      }

      var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor rokit-vendor">' + spacedVendor + '</div>' : '';
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    } else {
      var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div>' + ' ' + '</div>' : '';
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    }

    var wishListHtml = '<span class="smartwishlist rokit-wishlist" data-product="'+ data.id +'" data-variant="'+ data.variants[0].id +'"></span>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, wishListHtml);
    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);

    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);


    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      let productCountCurrent = document.querySelector(".product-count-current");
      let productCountDisplay = document.querySelector(".product-count-display");
      let productCountGrid = document.querySelectorAll(".grid-product").length;
      productCountCurrent.innerHTML = currentPage === 1 ? currentPage : productCountGrid === Globals.queryParams.limit ? ((parseInt(productCountGrid) * currentPage) - parseInt(productCountGrid)) + 1 : totalProduct - productCountGrid;
      productCountDisplay.innerHTML = productCountGrid === Globals.queryParams.limit ? currentPage * parseInt(productCountGrid) : totalProduct;

      return paginationHtml;
    }

    if (totalPage === 1) {
      let productCountCurrent = document.querySelector(".product-count-current");
      let productCountDisplay = document.querySelector(".product-count-display");
      let productCountGrid = document.querySelectorAll(".grid-product").length;
      productCountCurrent.innerHTML = currentPage === 1 ? currentPage : productCountGrid === Globals.queryParams.limit ? ((parseInt(productCountGrid) * currentPage) - parseInt(productCountGrid)) + 1 : totalProduct - productCountGrid;
      productCountDisplay.innerHTML = productCountGrid === Globals.queryParams.limit ? currentPage * parseInt(productCountGrid) : totalProduct;
    } 

    return '';
  };

  // Build Pagination Text

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '<option value="" disabled selected>Sort by</option>';
    	for (var k in sortingArr) {
    	  sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
    	}
    	html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    if (data.event_type != 'init' && typeof ReloadSmartWishlist !== 'undefined') { ReloadSmartWishlist(); }
    // Hover color swatch
    onColorSwatchHover();
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      jQ('.js-drawer-open-collection-filters').on('click', function() {
        jQ('.' + Class.filterOption).each(function() {
          var showMoreType = jQ(this).data('show-more-type');
          if (showMoreType && jQ(this).data('display-type') != 'range') {
            self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
          }
        });
      });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product.toLocaleString("en-US"));
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product.toLocaleString("en-US"));
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);
    jQ('.boost-pfs-filter-total-product.pagination-block').html(totalProductText.replace('products', 'items'));

    // Build filter button text on mobile
    var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    if (numSelectedFilter) {
      jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    } else {
      jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    }
    theme.initQuickShop();
  };
  
//   FilterApi.beforeCall = function(){
//    Globals.queryParams.sort_first = ""
//     Globals.queryParams.product_available = false
//     Globals.queryParams.variant_available = false
//   }
  ProductPaginationDefault.prototype._onClickEvent = function(event) {
    event.preventDefault();
    Globals.internalClick = true;

    // Get the new page value
    var url;
    try {
      url = new URL(jQ(event.currentTarget).attr('href'));
    } catch (e) {
      url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
    }

    var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
    if (!pageValue || isNaN(pageValue)) pageValue = 1;

    // Apply filter
    FilterApi.setParam('page', pageValue);
    FilterApi.applyFilter('page');

    // Scroll to top of product list
    window.scrollTo({
      top: this.$productList.offset().top - 230,
      behavior: 'smooth'
    });
  }
})();

// Add a click event listener to '.js-drawer-open-collection-filters'
document.querySelector('.js-drawer-open-collection-filters').addEventListener('click', function() {
    // Check if the element '.boost-pfs-filter-option button' exists
    var filterButton = document.querySelector('.boost-pfs-filter-option button');
    if (filterButton) {
        // Trigger a click event on the first button
        filterButton.click();
    }
});